<div class="team-filter">
	<div class="team-filter__controls">
		<b-select class="team-filter__select" expanded size="is-medium" v-model="activeCategoryIndex">
			<option :value="index" :key="category.value" v-for="(category, index) in categories">
				{{category.label}}
			</option>
		</b-select>
		<b-tabs class="team-filter__tabs" type="is-toggle" v-model="activeCategoryIndex">
			<b-tab-item v-for="category in categories" :key="category.value" :label="category.label"></b-tab-item>
		</b-tabs>
	</div>
	<div class="team-filter__grid">
		<team-filter-card :person="person" :role="activeRole" :key="person.id" v-for="person in filteredPersons" />
	</div>
</div>
